import React, { useEffect, useState } from "react";
import {
    CAlert,
    CButton,
    CCard,
    CCardBody,
    CCardGroup,
    CContainer,
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText, CNavItem,
    CRow
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {cilLockLocked, cilUser} from "@coreui/icons";
import sha256 from "sha256";
import qs from 'query-string';

import {Loading} from "../../../components/common";
import { useLocation, useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import {accountActions} from "../../../redux-store/actions/account";

import * as loginMethod from "../../../api/method/loginMethod";
import {footerActions} from "../../../redux-store/actions/footer";

function Login(props) {
    const [accountId, setAccountId] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ visible: false, message: "" });

    const navigate = useNavigate();
    const {search} = useLocation();

    const onKeyPress = (e) => {
        if (e.keys === "Enter") {
            acceptLogin();
        }
    };

    useEffect(() => {
        // 하단 탭 초기화
        props.initFooterMenu();

        if (search.length > 0) {
            const query = qs.parse(search);
            const login = {
                id: query.id,
                password: query.pass
            }
            acceptLogin(login);
        }
    }, [])

    const isValidation = (accountId, password) => {
        if (accountId.length === 0) {
            setError({ visible: true, message: "ID를 입력해주세요."});
            return false;
        }
        if (password.length === 0) {
            setError({ visible: true, message: "비밀번호를 입력해주세요."});
            return false;
        }
        return true;
    }

    const acceptLogin = async (login) => {
        setError({ visible: false, message: "" });
        setLoading(true);
        const params = {
            userId: login.id,
            password: login.password
        }
        loginMethod.acceptLogin(params).then((result) => {
            console.log(result);
            if (result.responseCode === "200") {
                // 성공
                props.setAccount(result.responseBody);
                checkPermission(result.responseBody);
            } else {
                setError({ visible: true, message: result.responseMessage});
            }
        })
            .finally(() => {
                setLoading(false);
            })
    };

    const checkPermission = (user) => {
        console.log("### props :: ", props);
        goMain();
    };

    const goMain = () => {
        // 하단 기본 탭을 추가한다
        const menu = {
            id: 0,
            component: CNavItem,
            name: '대시보드',
            to: '/main',
            auth: "3"
        }
        props.addFooterMenu(menu);
        navigate("/main");
    };

    return (
        <div className="bg-black min-vh-100 d-flex align-items-center justify-content-center"
             style={{
                 backgroundImage: `url("http://o2pos.spcnetworks.kr/files/login_bg.jpg")`,
                 backgroundRepeat: "no-repeat",
                 backgroundSize: "cover"
             }}>
            {loading ? <Loading/> : null}
            <div>
                <CRow style={{width: "30%"}}>
                    <center>
                        <h1 className="text-white"><strong>휴게소 영업정보 시스템</strong></h1>
                        <h4 className="text-danger">MEMBER LOGIN</h4>
                    </center>
                    <CCardGroup>
                        <CCard className="p-4">
                            <CCardBody>
                                {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
                                <CForm>
                                    <CInputGroup className="mb-3" size="lg">
                                        <CInputGroupText>
                                            <CIcon icon={cilUser}/>
                                        </CInputGroupText>
                                        <CFormInput
                                            placeholder="사용자 ID"
                                            autoComplete="username"
                                            onChange={(event) => {
                                                setAccountId(event.target.value);
                                            }}
                                        />
                                    </CInputGroup>
                                    <CInputGroup className="mb-4" size="lg">
                                        <CInputGroupText>
                                            <CIcon icon={cilLockLocked}/>
                                        </CInputGroupText>
                                        <CFormInput
                                            type="password"
                                            placeholder="비밀번호"
                                            autoComplete="current-password"
                                            onChange={(event) => {
                                                setPassword(event.target.value);
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    if (isValidation(accountId, password)) {
                                                        const login = {
                                                            id: accountId,
                                                            password: sha256(password)
                                                        }
                                                        acceptLogin(login);
                                                    }
                                                }
                                            }}
                                        />
                                    </CInputGroup>
                                </CForm>
                                <div className="d-grid gap-2">
                                    <CButton
                                        href="#"
                                        color="primary"
                                        size="lg"
                                        onClick={() => {
                                            if (isValidation(accountId, password)) {
                                                const login = {
                                                    id: accountId,
                                                    password: sha256(password)
                                                }
                                                acceptLogin(login);
                                            }
                                        }}
                                    >
                                        로그인
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CRow>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    const {account, footer} = state;
    return {
        account, footer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setAccount: (account) => {
            dispatch(accountActions.setAccount(account));
        },
        initFooterMenu: () => {
            dispatch(footerActions.initFooterMenu());
        },
        addFooterMenu: (menu) => {
            dispatch(footerActions.addFooterMenu(menu));
        },
        dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
